import { render } from "./app-header.vue?vue&type=template&id=332aa11e&scoped=true&ts=true"
import script from "./app-header.vue?vue&type=script&lang=ts"
export * from "./app-header.vue?vue&type=script&lang=ts"

import "./app-header.vue?vue&type=style&index=0&id=332aa11e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332aa11e"]])

export default __exports__